import { render, staticRenderFns } from "./DetaildedProcess.vue?vue&type=template&id=60e5df76&"
import script from "./DetaildedProcess.vue?vue&type=script&lang=js&"
export * from "./DetaildedProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports